import {MenuProvider, MenuButton, MenuButtonArrow, Menu, MenuItem} from '@ariakit/react'
import {faCircleUser, faCog, faPowerOff} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Button} from '@freckle/educator-materials/ts/components/button'
import {Flex} from '@freckle/educator-materials/ts/components/flex'
import {RenaissanceIcon} from '@freckle/educator-materials/ts/components/renaissance-icon'
import {Text} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {Routes} from '@freckle/school/ts/common/routers/routes'
import type {SchoolAdminAttrs} from '@freckle/school/ts/users/models/school-admin'
import {isManagedByRenaissance} from '@freckle/school/ts/users/models/school-admin'
import {logout} from './logout'
import {adminMenuIcon, menuButton, menu, menuItem, menuProvider} from './top-bar.module.scss'

type Props = {
  schoolAdmin: SchoolAdminAttrs
}

export function TopBar(props: Props) {
  const {schoolAdmin} = props
  const {t} = useSafeTranslation()

  return (
    <div className={menuProvider} role="navigation">
      <nav>
        <MenuProvider>
          <MenuButton className={menuButton}>
            <Text style="body-2" id="admin-dropdown">
              <Flex alignItems="center">
                <FontAwesomeIcon icon={faCircleUser} className={adminMenuIcon} />
                <span>{t('TOP_BAR_NAV_DROPDOWN_TITLE')}</span>
                <MenuButtonArrow />
              </Flex>
            </Text>
          </MenuButton>
          <Menu className={menu}>
            <MenuItem
              render={
                <a href={Routes.settings()} className={menuItem}>
                  <FontAwesomeIcon icon={faCog} /> {t('TOP_BAR_NAV_MENU_ITEM_SETTINGS')}
                </a>
              }
            />
            {isManagedByRenaissance(schoolAdmin) ? (
              <MenuItem
                render={
                  <a href={Routes.ssoLogoutToRenaissance()} className={menuItem}>
                    <Flex alignItems="center">
                      <RenaissanceIcon />
                      {t('TOP_BAR_NAV_MENU_ITEM_RENAISSANCE_HOME')}
                    </Flex>
                  </a>
                }
              />
            ) : null}
            <MenuItem
              render={
                <Button className={menuItem} style="link" onClick={logout}>
                  <FontAwesomeIcon icon={faPowerOff} /> {t('TOP_BAR_NAV_MENU_ITEM_LOG_OUT')}
                </Button>
              }
            />
          </Menu>
        </MenuProvider>
      </nav>
    </div>
  )
}
